import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {GETLISTEMPLEADOSCALENDARIOXTIENDA} from '../../ComisionesModule/queries/comision.query';
import {getLoginUser} from '../../CoreModule/services/usuario.services';
import {
  REPORTEESTADO,
  REPORTEINDGENERAL,
  REPORTEINDICADORES,
  REPORTEMIXVENTAS, REPORTEMIXVENTASPARTICIPANTES,
  REPORTEPARTICIPACION,
  REPORTEVENTAS
} from '../queries/reportes.query';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {Observable} from 'rxjs';

@Injectable()
export class ReporteServices {

  public indicadores: any = {};
  public mostrarSemaforo: boolean = false;

  public obsSendDashboard: Observable<any>;

  constructor(private apollo: Apollo, private ss: SocketServices) {
    this.obsSendDashboard = this.ss.registrarEvento("sendReporteDashboard");
  }

  getListEmpleadosCalendarioXTienda(inicio: any, fin: any, tienda: string) {
    return this.apollo.query<any>({
      query: GETLISTEMPLEADOSCALENDARIOXTIENDA,
      variables: {
        inicio: inicio,
        fin: fin,
        tienda: tienda
      }
    });

  }

  getInfoDashboard(entidad: number, idEntidad: any, fecha1: string, fecha2: string) {
    this.ss.enviarEvento('getReporteDashboard', {entidad: entidad, idEntidad: idEntidad, fecha1: fecha1, fecha2: fecha2});
  }


  devolverReporteEstado(entidad: number, idEntidad: any, fecha1: string, fecha2: string) {
    return this.apollo.query<any>({
      query: REPORTEESTADO,
      variables: {
        entidad: entidad,
        idUser: getLoginUser(),
        idEntidad: idEntidad,
        fecha1: fecha1,
        fecha2: fecha2
      }
    });
  }

  devolverReporteVentas(entidad: number, idEntidad: string, fecha1: string, fecha2: string) {
    return this.apollo.query<any>({
      query: REPORTEVENTAS,
      variables: {
        entidad: entidad,
        idUser: getLoginUser(),
        idEntidad: idEntidad,
        fecha1: fecha1,
        fecha2: fecha2
      }
    });
  }

  devolverReporteIndicadores(entidad: number, idEntidad: string, fecha1: string, fecha2: string) {
    return this.apollo.query<any>({
      query: REPORTEINDICADORES,
      variables: {
        entidad: entidad,
        idUser: getLoginUser(),
        idEntidad: idEntidad,
        fecha1: fecha1,
        fecha2: fecha2
      }
    });
  }

  devolverReporteParticipacion(entidad: number, idEntidad: string, fecha1: string, fecha2: string) {
    return this.apollo.query<any>({
      query: REPORTEPARTICIPACION,
      variables: {
        entidad: entidad,
        idUser: getLoginUser(),
        idEntidad: idEntidad,
        fecha1: fecha1,
        fecha2: fecha2
      }
    });
  }

  devolverReporteIndGeneral(entidad: number, idEntidad: string, fecha1: string, fecha2: string) {
    return this.apollo.query<any>({
      query: REPORTEINDGENERAL,
      variables: {
        entidad: entidad,
        idUser: getLoginUser(),
        idEntidad: idEntidad,
        fecha1: fecha1,
        fecha2: fecha2
      }
    });
  }

  devolverReporteMixVenta(entidad: number, idEntidad: string, fecha1: string, fecha2: string) {
    return this.apollo.query<any>({
      query: REPORTEMIXVENTAS,
      variables: {
        entidad: entidad,
        idUser: getLoginUser(),
        idEntidad: idEntidad,
        fecha1: fecha1,
        fecha2: fecha2
      }
    });
  }

  devolverReporteMixVentaParticipantes(entidad: number, idEntidad: string, fecha1: string, fecha2: string) {
    return this.apollo.query<any>({
      query: REPORTEMIXVENTASPARTICIPANTES,
      variables: {
        entidad: entidad,
        idUser: getLoginUser(),
        idEntidad: idEntidad,
        fecha1: fecha1,
        fecha2: fecha2
      }
    });
  }

}
